import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';


export default function Users() {
  const [users, setUsers]     = useState([]);
  const [stats, setStats]     = useState(null);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');
  const [confirmAction, setConfirmAction] = useState(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const [ud, sd] = await Promise.all([api.getUsers(), api.getUserStats()]);
      setUsers(ud.users);
      setStats(sd);
    } catch(e) {
      setError('Fehler beim Laden');
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(user) {
    setConfirmAction(null);
    setError('');
    try {
      await api.deleteUser(user.id);
      await load();
    } catch(e) {
      setError(e.message || 'Fehler beim Löschen');
    }
  }

  async function handleToggleAdmin(user) {
    setConfirmAction(null);
    setError('');
    try {
      await api.updateUser(user.id, { is_admin: !user.is_admin });
      await load();
    } catch(e) {
      setError(e.message || 'Fehler beim Ändern');
    }
  }

  const s = {
    wrap:   { padding: '28px 32px', maxWidth: 1100 },
    h1:     { fontSize: '1.4rem', color: 'var(--admin-text)', fontFamily: 'Inter,sans-serif', fontWeight: 600, marginBottom: 6 },
    sub:    { fontSize: '.78rem', color: 'var(--admin-text-dim)', marginBottom: 28 },
    topRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
    secLbl: { fontSize: '.7rem', fontWeight: 600, color: 'var(--admin-text-dim)', textTransform: 'uppercase', letterSpacing: '.08em' },
    btn:    { background: 'var(--admin-btn-primary)', border: 'none', color: '#fff', borderRadius: 5, padding: '7px 16px', fontSize: '.75rem', fontWeight: 600, cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
    table:  { width: '100%', borderCollapse: 'collapse', fontSize: '.78rem', background: 'var(--admin-bg)', border: '1px solid var(--admin-border)', borderRadius: 8, overflow: 'hidden' },
    th:     { padding: '10px 16px', textAlign: 'left', color: 'var(--admin-text-dim)', fontWeight: 600, background: 'var(--admin-bg-dark)', borderBottom: '1px solid var(--admin-border)' },
    tdFn:   (i) => ({ padding: '10px 16px', borderBottom: '1px solid var(--admin-border)', background: i % 2 === 0 ? 'var(--admin-bg)' : 'var(--admin-bg-alt)' }),
    btnDel:     { background: 'none', border: '1px solid var(--admin-danger)', color: 'var(--admin-danger)', borderRadius: 4, padding: '3px 10px', fontSize: '.68rem', cursor: 'pointer', marginLeft: 6 },
    btnEdt:     { background: 'none', border: '1px solid var(--admin-border)', color: 'var(--admin-text-muted)', borderRadius: 4, padding: '3px 10px', fontSize: '.68rem', textDecoration: 'none', display: 'inline-block' },
    btnAdmin:   { background: 'none', border: '1px solid var(--admin-accent)', color: 'var(--admin-accent)', borderRadius: 4, padding: '3px 10px', fontSize: '.68rem', cursor: 'pointer', marginLeft: 6 },
    btnDeAdmin: { background: 'none', border: '1px solid var(--admin-text-dim)', color: 'var(--admin-text-dim)', borderRadius: 4, padding: '3px 10px', fontSize: '.68rem', cursor: 'pointer', marginLeft: 6 },
  };

  return (
    <div style={s.wrap}>
      <h1 style={s.h1}>Benutzer-Verwaltung</h1>
      <p style={s.sub}>Benutzer anlegen, bearbeiten und löschen.</p>

      {stats && (
        <div style={{display:'flex', gap:12, marginBottom:24}}>
          {[['Gesamt', stats.total_users], ['Admins', stats.total_admins]].map(([l,v]) => (
            <div key={l} style={{background:'var(--admin-bg)',border:'1px solid var(--admin-border)',borderRadius:8,padding:'14px 20px',textAlign:'center',minWidth:100}}>
              <div style={{fontSize:'1.8rem',fontWeight:700,color:'var(--admin-accent)',lineHeight:1}}>{v}</div>
              <div style={{fontSize:'.65rem',color:'var(--admin-text-dim)',textTransform:'uppercase',letterSpacing:'.06em',marginTop:4}}>{l}</div>
            </div>
          ))}
        </div>
      )}

      <div style={s.topRow}>
        <span style={s.secLbl}>Alle Benutzer</span>
        <Link to="/admin/users/new" style={s.btn}>+ Neuer Benutzer</Link>
      </div>

      {error && (
        <div style={{ background: 'color-mix(in srgb, var(--admin-danger) 10%, transparent)', border: '1px solid var(--admin-danger)', borderRadius: 6, padding: '10px 14px', color: 'var(--admin-danger)', fontSize: '.78rem', marginBottom: 16 }}>
          {error}
        </div>
      )}

      {confirmAction && (
        <div style={{ background: 'color-mix(in srgb, var(--admin-danger) 8%, transparent)', border: '1px solid var(--admin-danger)', borderRadius: 6, padding: '10px 16px', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'space-between', fontSize: '.78rem', color: 'var(--admin-text)' }}>
          <span>
            {confirmAction.type === 'delete'
              ? <>Benutzer <strong>„{confirmAction.user.username}"</strong> wirklich löschen?</>
              : <><strong>„{confirmAction.user.username}"</strong> wirklich {confirmAction.user.is_admin ? 'Admin-Rechte entziehen' : 'zum Admin machen'}?</>}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ background: 'var(--admin-danger)', border: 'none', color: '#fff', borderRadius: 4, padding: '4px 12px', fontSize: '.72rem', cursor: 'pointer' }}
              onClick={() => confirmAction.type === 'delete' ? handleDelete(confirmAction.user) : handleToggleAdmin(confirmAction.user)}>
              Ja
            </button>
            <button style={{ background: 'none', border: '1px solid var(--admin-border)', color: 'var(--admin-text-muted)', borderRadius: 4, padding: '4px 12px', fontSize: '.72rem', cursor: 'pointer' }}
              onClick={() => setConfirmAction(null)}>
              Abbrechen
            </button>
          </div>
        </div>
      )}

      {loading ? (
        <p style={{color:'var(--admin-text-dim)',fontSize:'.78rem'}}>Lade...</p>
      ) : (
        <table style={s.table}>
          <thead>
            <tr>
              {['Benutzername','Email','Rolle','Erstellt','Aktionen'].map(h => (
                <th key={h} style={s.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((u, i) => (
              <tr key={u.id}>
                <td style={s.tdFn(i)}><span style={{color:'var(--admin-text)',fontWeight:600}}>{u.username}</span></td>
                <td style={{...s.tdFn(i),color:'var(--admin-text-muted)'}}>{u.email || '—'}</td>
                <td style={s.tdFn(i)}>
                  {u.is_admin
                    ? <span style={{color:'var(--admin-accent)',fontWeight:600,fontSize:'.7rem'}}>⚙ Admin</span>
                    : <span style={{color:'var(--admin-text-dim)',fontSize:'.7rem'}}>Benutzer</span>}
                </td>
                <td style={{...s.tdFn(i),color:'var(--admin-text-dim)'}}>{new Date(u.created_at).toLocaleDateString('de-DE')}</td>
                <td style={s.tdFn(i)}>
                  <Link to={`/admin/users/edit/${u.id}`} style={s.btnEdt}>✏ Bearbeiten</Link>
                  <button
                    style={u.is_admin ? s.btnDeAdmin : s.btnAdmin}
                    onClick={() => { setError(''); setConfirmAction({ type: 'toggleAdmin', user: u }); }}>
                    {u.is_admin ? '↓ Admin entziehen' : '↑ Admin machen'}
                  </button>
                  <button style={s.btnDel} onClick={() => { setError(''); setConfirmAction({ type: 'delete', user: u }); }}>✕ Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

    </div>
  );
}
